import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["prefix", "warning"]
  static values = {
    originalPrefix: String,
    taskCount: { type: Number, default: 0 },
    confirmMessage: String
  }

  connect() {
    this.updateWarning()
  }

  prefixChanged() {
    this.updateWarning()
  }

  updateWarning() {
    if (!this.hasWarningTarget) return

    this.warningTarget.classList.toggle("d-none", !this.prefixChangedFromOriginal())
  }

  confirmSubmit(event) {
    if (!this.prefixChangedFromOriginal()) return
    if (this.taskCountValue <= 0) return
    if (!window.confirm(this.confirmMessageValue)) {
      event.preventDefault()
    }
  }

  prefixChangedFromOriginal() {
    return this.prefixTarget.value.trim() !== this.originalPrefixValue.trim()
  }
}
